import * as React from 'react';
import {Link} from "react-router-dom";

export const DisabledContent = props => (
    <div className={'disabled-content'}>
        Diese Inhalte sind in der kostenlosen Version nur zeitlich begrenzt verfügbar. <a href={'/subscriptions'} target={'_blank'}>Klicke hier</a>, um die Vollversion zu buchen.
    </div>
);
